import { render, staticRenderFns } from "./EdpResultado.vue?vue&type=template&id=7d6d60c1"
import script from "./EdpResultado.vue?vue&type=script&lang=js"
export * from "./EdpResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports